<div class="card mb-4">
  <h6 class="card-header">
    Vacancy Overview
  </h6>
  <div class="row no-gutters row-bordered">
    <div class="col-sm-12 p-4">
      <table class="table table-striped">
        <thead>
        <tr>
          <th>Vacancy</th>
          <th>Status</th>
          <th>Deadline</th>
          <th>Candidates (Matching)</th>
          <th>Internal matches</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let vacancy of getVacancies() | filter:canView()" class="certificate-add" (click)="view(vacancy)">
          <td>{{vacancy.shortDescription}}</td>
          <td>{{getReadableStatus(vacancy)}}</td>
          <td>{{vacancy.deadline | date:'shortDate'}}</td>
          <td>{{getNumCandidates(vacancy)}} ({{getNumMatchingCandidates(vacancy)}})</td>
          <td>{{getNumMatchingInternals(vacancy)}}</td>
        </tr>
        <tr *ngIf="(getVacancies() | filter:canView()).length === 0">
          <td colspan="3" style="text-align: center">
            You don't have any vacancies currently
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

</div>
